/**
 * Set of colors being re-used for models and components
 */
export const color = {
  white: '#FFF',
  grasGreen: '#004400',
  windowGlass: '#FFF',
  windowBorders: '#A0522D',
  windowBlech: '#3e4a57',
  anthracite: '#C0C0C0',
  terraceGray: '#a6a6a5',
  sunblock: '#D99058',
  hauswand: '#E6E6E6',
  dockGreen: '#4e844e',
}
